export const FAIXAS_DEFAULT = [
  {
    dias: 7,
    label: "Até 7 dias",
    mensagem:
      "Oi, {nome_cliente}! 😊\n\n" +
      "Já faz alguns dias que não vemos o {nome_pet} por aqui e estamos com saudade! 🐾🧡\n\n" +
      "Manter os banhos em dia ajuda a cuidar da pele e da pelagem, além de deixar o {nome_pet} limpinho, cheiroso e confortável por mais tempo. 🛁✨\n\n" +
      "Que tal aproveitar para agendar uma nova visita?\n\n" +
      "Nossa equipe está esperando o {nome_pet} para mais um momento de muito cuidado, carinho e atenção.",
  },
  {
    dias: 15,
    label: "Até 15 dias",
    mensagem:
      "Oi, {nome_cliente}! 😊\n\n" +
      "Já faz um tempinho que não vemos o {nome_pet} por aqui e estamos sentindo falta dessa fofura! 🐾🧡\n\n" +
      "Que tal trazer o {nome_pet} para ficar limpinho, cheiroso e receber todo aquele cuidado e carinho que ele merece?\n\n" +
      "Nossa equipe vai adorar receber vocês novamente! ✨\n\n" +
      "Vamos agendar o próximo banho? 🛁🐶",
  },
  {
    dias: 30,
    label: "Até 30 dias",
    mensagem:
      "Oi, {nome_cliente}! Tudo bem? 🐾\n\n" +
      "Você sabia que manter uma rotina de banhos vai muito além de deixar o {nome_pet} limpinho e cheiroso? 🛁✨\n\n" +
      "Os banhos regulares ajudam a:\n\n" +
      "- Manter a saúde da pele e da pelagem\n" +
      "- Proporcionar mais conforto e bem-estar\n" +
      "- Cuidar da higiene e evitar o acúmulo de sujeira\n" +
      "- Manter o pet limpinho, cheiroso e bem cuidado\n\n" +
      "Nossa equipe está pronta para receber o {nome_pet} com muito carinho, atenção e cuidado.\n\n" +
      "Vamos agendar o próximo banho? 🐶🧡",
  },
  {
    dias: 45,
    label: "Até 45 dias",
    mensagem:
      "O {nome_pet} já está há um tempinho sem passar por aqui...\n\n" +
      "Depois de alguns dias sem banho, a pele e os pelos podem acumular sujeiras, oleosidade e desconfortos que impactam diretamente o bem-estar do seu pet.\n\n" +
      "Manter uma rotina de cuidados ajuda em:\n" +
      "✨ Pele mais saudável\n" +
      "✨ Pelos mais limpos, hidratados e protegidos\n" +
      "✨ Mais conforto e higiene no dia a dia\n" +
      "✨ Redução de odores e nós\n" +
      "✨ Mais bem-estar e relaxamento\n\n" +
      "Aqui na Petland, cada banho é pensado com muito carinho, atenção e cuidado em todas as etapas.\n\n" +
      "Que tal agendar uma nova visita? Vai ser um prazer receber vocês novamente!",
  },
  {
    dias: null,
    label: "Mais de 45 dias",
    mensagem: "",
  },
];
